export default {
    data() {
        return {
            internalValue: this.value || this.initial
        };
    },
    props: {
        initial: {
            type: String,
            default: ''
        },
        value: {
            type: String,
            default: null
        },
        name: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: null
        },
        error: {
            type: Boolean,
            default: false
        },
        errorMessage: {
            type: String,
            default: 'Error'
        },
        readonly: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        val() {
            return this.value || this.internalValue;
        }
    },
};
